"use client"

import * as React from "react"
import * as LabelPrimitive from "@radix-ui/react-label"

import { cn } from "@/utils/utils"
import { Text } from "../information/text"
import { labelStyleDriver } from "@/utils/componentStyle"

function Label({
  className,
  children,
  ...props
}: React.ComponentProps<typeof LabelPrimitive.Root>) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={cn(labelStyleDriver.root, className)}
      {...props}
    >
      {typeof children === "string" || typeof children === "number" ? (
        <Text as="p">{children}</Text>
      ) : (
        children
      )}
    </LabelPrimitive.Root>
  )
}

export { Label }
